const orvalApiClientKey = Symbol("orvalApiClient");
export function createOrvalRequestOptions(api, init = {}) {
    return {
        ...init,
        [orvalApiClientKey]: api,
    };
}
export async function orvalRequest(input, init) {
    const options = init;
    const api = options[orvalApiClientKey];
    if (!api) {
        throw new Error("Orval request missing API client. Pass createOrvalRequestOptions(api).");
    }
    const requestInit = { ...options };
    delete requestInit[orvalApiClientKey];
    delete requestInit.params;
    const response = await api.fetch(appendQueryParams(input, options.params), requestInit);
    const body = [204, 205, 304].includes(response.status) ? null : await response.text();
    const data = parseBody(body, response.headers);
    if (!response.ok) {
        const error = new Error(`Request failed: ${response.status} ${response.statusText}`);
        error.info = data;
        error.status = response.status;
        throw error;
    }
    return {
        data,
        status: response.status,
        headers: response.headers,
    };
}
function appendQueryParams(input, params) {
    if (!params || isEmptyQueryParams(params))
        return input;
    if (input instanceof URL) {
        const url = new URL(input);
        appendParams(url.searchParams, params);
        return url;
    }
    const [withoutHash = "", hash = ""] = input.split("#", 2);
    const [pathname, search = ""] = withoutHash.split("?", 2);
    const searchParams = new URLSearchParams(search);
    appendParams(searchParams, params);
    const query = searchParams.toString();
    return `${pathname}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`;
}
function appendParams(searchParams, params) {
    if (params instanceof URLSearchParams) {
        params.forEach((value, key) => {
            searchParams.append(key, value);
        });
        return;
    }
    Object.entries(params).forEach(([key, value]) => {
        const values = Array.isArray(value) ? value : [value];
        values.forEach((item) => {
            if (item !== undefined) {
                searchParams.append(key, item === null ? "null" : item.toString());
            }
        });
    });
}
function isEmptyQueryParams(params) {
    if (params instanceof URLSearchParams)
        return Array.from(params.keys()).length === 0;
    return Object.values(params).every((value) => {
        if (Array.isArray(value))
            return value.every((item) => item === undefined);
        return value === undefined;
    });
}
function parseBody(body, headers) {
    if (!body)
        return {};
    const contentType = headers.get("content-type")?.toLowerCase() ?? "";
    if (contentType.includes("json") || looksLikeJson(body)) {
        return JSON.parse(body);
    }
    return body;
}
function looksLikeJson(body) {
    const trimmed = body.trim();
    return trimmed.startsWith("{") || trimmed.startsWith("[");
}
//# sourceMappingURL=orval-request.js.map